import Order from '../order/Order';

function CompanyOrder() {
  return <Order isCompanyOrder />;
}

export default CompanyOrder;
